<template>
  <div class="map-wrapper">
    <div style="display: none;">
      <input
        id="pac-input"
        class="controls"
        type="text"
        placeholder="Search location..." />
    </div>
    <div class="map-container" ref="map-container"></div>
  </div>
</template>

<script>
import Vue from 'vue';

export default {
  props: {
    latitude: {
      type: Number,
      default: 51.509865
    },
    longitude: {
      type: Number,
      default: 0.0
    }
  },
  data () {
    return {
      map: null,
      marker: null,
      lat: this.latitude,
      lng: this.longitude,
    }
  },
  mounted () {
    // eslint-disable-next-line
    let myLatlng = new google.maps.LatLng(this.lat, this.lng);
    let mapOptions = {
      zoom: 12,
      center: myLatlng,
      mapTypeId: 'roadmap',
      disableDoubleClickZoom: true
    };

    // eslint-disable-next-line
    this.map = new google.maps.Map(this.$refs['map-container'], mapOptions);
    // eslint-disable-next-line
    this.marker = new google.maps.Marker({
      position: myLatlng,
      map: this.map
    });

    this.marker.setMap(this.map);
    // eslint-disable-next-line
    google.maps.event.addListener(this.map, 'dblclick', event => {
      this.marker.setPosition(event.latLng);
      this.$emit('locationUpdated', {
        lat: event.latLng.lat(),
        lng: event.latLng.lng()
      });
    });

    Vue.nextTick(() => {
      this.initAutocomplete();
    });
  },
  methods: {
    initAutocomplete () {
      // Create the search box and link it to the UI element.
      let input = document.getElementById('pac-input');
      // eslint-disable-next-line
      let autocomplete = new google.maps.places.Autocomplete(input);
      autocomplete.bindTo('bounds', this.map);
      autocomplete.setFields(['place_id', 'geometry', 'name']);
      // eslint-disable-next-line
      this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(input);

      autocomplete.addListener('place_changed', () => {
        let place = autocomplete.getPlace();

        if (!place.geometry) {
          return;
        }

        this.map.setCenter(place.geometry.location);
        this.map.setZoom(12);
        this.marker.setPlace({
          placeId: place.place_id,
          location: place.geometry.location
        });

        this.$emit('locationUpdated', {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng()
        });
      });
    }
  }
}
</script>

<style lang="scss">
.map-wrapper {
  height: 400px;

  .map-container {
    border: 1px solid var(--secondary);
    border-radius: 3px;
    height: 400px;
    width: 100%;
  }

  .controls {
    background-color: #fff;
    border-radius: 2px;
    border: 1px solid transparent;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
    box-sizing: border-box;
    font-family: Roboto;
    font-size: 15px;
    font-weight: 300;
    height: 38px;
    margin-left: 17px;
    margin-top: 10px;
    outline: none;
    padding: 0 11px 0 13px;
    text-overflow: ellipsis;
    width: 400px;
  }

  .controls:focus {
    border-color: #4d90fe;
  }
}
</style>
